import * as trace from 'owa-trace';
import { ActionMetaInfo } from 'mini-app-context';

/**
 * The map of signal name to array of resolve functions which can be registered.
 * Using array to support the scenario where multiple parallel journeys can then potentially await on a single signal.
 */
const signalToPromiseResolverMap: {
    [key: string]: ((actionMetaInfo: ActionMetaInfo) => void)[];
} = {};

/**
 * Middleware to track the signals for the capability to await on a signal which is yet to come.
 * @param next The next function (here a possible middleware ) to call
 * @param metaInfo The signal payload
 */
export default function signalTrackerListener(metaInfo: ActionMetaInfo, ctx: any) {
    const { name } = metaInfo;
    if (signalToPromiseResolverMap[name]) {
        try {
            signalToPromiseResolverMap[name].forEach(resolve => {
                resolve(metaInfo);
            });
            delete signalToPromiseResolverMap[name];
        } catch (error) {
            trace.errorThatWillCauseAlert('Error in resolving the promise.' + error.message);
            delete signalToPromiseResolverMap[name];
        }
    }
}

/**
 * The method to be used by the journey function to await on a signal yet to happen.
 * @param signalName Name of the signal to track
 */
export function onSignal(signalName: string): Promise<ActionMetaInfo> {
    return new Promise(resolve => {
        signalToPromiseResolverMap[signalName] = signalToPromiseResolverMap[signalName] || [];
        signalToPromiseResolverMap[signalName].push(resolve);
    });
}
